<template>
  <div class="code-space">
    <IDEEditor :files="files" @save="saveFile"/>
  </div>
</template>

<script>
import IDEEditor from '../editor/index'
import { saveFile } from '@/api/template/file'

export default {
  name: 'IDECodeSpace',
  components: { IDEEditor },
  props: {
    // 已打开的文件
    files: {
      default () {
        return []
      }
    }
  },
  methods: {
    // 保存文件
    saveFile (file) {
      if (file.__saving) {
        return
      }
      file.__saving = true
      const form = {}
      for (const key in file) {
        if (key.startsWith('__')) {
          continue
        }
        form[key] = file[key]
      }
      saveFile(form)
        .then(data => {
          file.__isEdited = false
          // 为属性填充ID
          if (data.props.length > 0) {
            for (const prop of data.props) {
              const targetIndex = file.props.findIndex(p => p.frontId === prop.frontId)
              const target = file.props[targetIndex]
              if (target == null) {
                continue
              }
              // 新属性，赋值ID
              if (target.id == null) {
                target.id = prop.id
              }
              // 已删除的属性，删除记录
              else if (target.id < 0) {
                file.props.splice(targetIndex, 1)
              }
            }
          }
        })
        .catch(e => {
          this.$tip.apiFailed(e)
        })
        .finally(() => {
          file.__saving = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
@import "../variables";
.code-space {
  height: 100%;
  background: $code-space-background;
}
</style>
